<template>
    <v-dialog v-model="d" width="30%" persistent>
        <v-card>
            <v-card-title>Delete Repeat</v-card-title>
            <v-card-text>
                Are you sure you want to delete this repeat for {{active.originalBookingName}}?
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn :loading="isLoading" :disabled="isLoading" text color="primary" @click="closeDialog">Cancel</v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading" color="error" @click="deleteRepeat">Delete Repeat</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapActions, mapMutations, mapState} from "vuex";
    import {RepeatsHttp} from "../../http/RepeatsHttp";

    export default {
        name: "DeleteRepeatModal",
        data() {
            return {
                isLoading: false
            }
        },
        computed: {
            ...mapState("repeats", ["deleteRepeatDialog", "activeRepeat"]),
            d: {
                get() {
                    return this.deleteRepeatDialog;
                }
            },
            active: {
                get() {
                    return this.activeRepeat;
                }
            }
        },
        methods: {
            ...mapActions("repeats", ["setActiveRepeat", "setManageDeleteRepeatDialog", "setRepeats"]),
            ...mapMutations("app", ["setToast"]),
            async closeDialog() {
                await this.setActiveRepeat({});
                await this.setManageDeleteRepeatDialog(false);
            },
            async deleteRepeat() {
                try {
                    this.isLoading = true;
                    await RepeatsHttp.deleteRepeat(this.active._id);
                    this.setToast({color: 'success', text: 'Repeat deleted successfully', show: true});
                    await this.setRepeats();
                    await this.setActiveRepeat({});
                    await this.setManageDeleteRepeatDialog(false);
                } catch (err) {
                    this.setToast({color: 'error', text: err.response.data, show: true})
                } finally {
                    this.isLoading = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
